(() => {
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.thumbsTrack = this.querySelector('[data-gallery-thumbs]');
      this.current = 0;

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          this.select(parseInt(thumb.dataset.galleryThumb, 10));
        });
      });

      this.slides.forEach((slide) => {
        slide.addEventListener('click', (e) => {
          if (this._swipedRecently) { e.preventDefault(); e.stopPropagation(); return; }
          this.select((this.current + 1) % this.slides.length);
        });
      });

      // Stage prev / next overlay arrows
      this.querySelector('[data-gallery-prev]')?.addEventListener('click', (e) => {
        e.stopPropagation();
        this.select((this.current - 1 + this.slides.length) % this.slides.length);
      });
      this.querySelector('[data-gallery-next]')?.addEventListener('click', (e) => {
        e.stopPropagation();
        this.select((this.current + 1) % this.slides.length);
      });

      // Thumbnail scroll arrows
      this.querySelector('[data-thumbs-prev]')?.addEventListener('click', () => this.scrollThumbs(-1));
      this.querySelector('[data-thumbs-next]')?.addEventListener('click', () => this.scrollThumbs(1));

      // Touch swipe on main stage
      this.initSwipe();
    }

    initSwipe() {
      const stage = this.querySelector('[data-gallery-stage]');
      if (!stage || this.slides.length <= 1) return;

      let startX = 0, startY = 0, deltaX = 0, active = false;
      const THRESHOLD = 40;

      stage.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        deltaX = 0;
        active = true;
      }, { passive: true });

      stage.addEventListener('touchmove', (e) => {
        if (!active || e.touches.length !== 1) return;
        deltaX = e.touches[0].clientX - startX;
        const deltaY = e.touches[0].clientY - startY;
        // Cancel if vertical gesture dominates (user is scrolling page)
        if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 10) {
          active = false;
        }
      }, { passive: true });

      stage.addEventListener('touchend', () => {
        if (!active) return;
        active = false;
        if (Math.abs(deltaX) < THRESHOLD) return;
        this._swipedRecently = true;
        setTimeout(() => { this._swipedRecently = false; }, 400);
        if (deltaX < 0) {
          this.select((this.current + 1) % this.slides.length);
        } else {
          this.select((this.current - 1 + this.slides.length) % this.slides.length);
        }
      });

      stage.addEventListener('touchcancel', () => { active = false; });
    }

    select(index) {
      this.current = index;
      this.slides.forEach((slide, i) => {
        const active = i === index;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) slide.removeAttribute('tabindex');
        else slide.setAttribute('tabindex', '-1');
      });
      this.thumbs.forEach((thumb, i) => {
        thumb.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      const activeThumb = this.thumbs[index];
      if (activeThumb && this.thumbsTrack) {
        activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    scrollThumbs(dir) {
      if (!this.thumbsTrack) return;
      const thumb = this.thumbs[0];
      if (!thumb) return;
      const gap = parseFloat(getComputedStyle(this.thumbsTrack).gap || 8);
      const step = thumb.getBoundingClientRect().width + gap;
      this.thumbsTrack.scrollBy({ left: step * 3 * dir, behavior: 'smooth' });
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }
})();
